module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "title": "1. Naturalism, Formalism, Phenomenology, and Semiology in Postmodern Philosophy"
    }
  }, [_c('p', {
    staticClass: "chap_no",
    attrs: {
      "id": "ch1"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10",
      "title": "10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Contents#rch1"
    }
  }, [_vm._v("ONE")])])]), _vm._v(" "), _c('p', {
    staticClass: "image-ch"
  }, [_c('img', {
    staticStyle: {
      "width": "8%"
    },
    attrs: {
      "alt": "",
      "src": "images/titlea.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chap_title"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Contents#rch1"
    }
  }, [_c('b', [_vm._v("Naturalism, Formalism, Phenomenology, and Semiology in Postmodern Philosophy")])])]), _vm._v(" "), _c('p', {
    staticClass: "h1-c"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("FOREIGN BODIES, FOREIGN MINDS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_para"
  }, [_c('i', [_vm._v("Embassytown")]), _vm._v(", a novel by science fiction writer China Miéville, describes a species of nonhuman but intelligent beings who inhabit an alien planet, Arieka, at the farthest edge of the known universe."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-1",
      "id": "fn1-1"
    }
  }, [_vm._v("1")])]), _vm._v(" The Ariekei are described as almost grotesquely alien, and their planet, invaded and inhabited by a contingent of human administrators and diplomats, presents an extreme version of the culture/nature distinction. Briefly stated, it is a story about fundamentalism in language brought about by an extreme commitment to reference and true propositions. On the human side, there is Embassytown, a small, enclosed, artificial environment where even the air has to be manufactured. Featuring brick and ivy, bureaucratic and planetary politics, it is a place where language does not refer to an outside because it is emblematic of a formal, syntactical expression of order, and so is not concerned with reference—that is, the truth or falsity of its statements.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("But on the Ariekei side, it’s all biological, consisting of polymers and “biorigged” flesh such that even their dwelling places and technology are purely biological. The Ariekei walk on four spiderlike legs ending in hooves; their bodies bear external spines, their heads, dark hair, and their faces, eye antlers. They have two mouths and two awkward coral-like wings, a giftwing for manipulation under the turn mouth and a fanwing, for hearing, behind the cut mouth. Wings and eye antlers all retract or furl and emerge like those of sea creatures or light-sensitive plants. The Ariekei are called “Hosts” by their human occupiers; mature Hosts are accompanied by battery creatures (Zelles), and the older ones grow edible sacs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11",
      "title": "11"
    }
  }, [_vm._v("Communication between Ariekei and humans is difficult. The Ariekei consist of and are embedded in pure biology, pure nature. Ariekei language and thoughts are indistinguishable; they operate without the influence of artifice, including writing; thus their minds and language are profoundly naturalized. As a result, when a non-Ariekei speaks the Ariekei language, unless the speaker is somehow able to unite mind and language, Ariekei hear only noise. The meaning is not in the sound but only in the mind. Meaning is conveyed in thoughts so much so that words do not signify and are not symbolic—that is, words are their own referents.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("The strange bodies of the Ariekei dictate that they speak simultaneously with their two harmonizing mouths, the “cut” above on the neck and the “turn” at the chest. Their language is the simultaneous enunciation of these sounds, which are representable as words written one over the other in the form of a fraction. Possibly because of their biological or material embeddedness and the indistinction between mind and word, the Ariekei language allows only affirmations, only true propositions. It gives them the capacity to speak of events that actually are taking place or have taken place in their biologically embedded world, and so the language allows them to tell no lies. Affirmation is the limiting limit of their semantics. This amounts to an extreme “naturalism” in language, whose philosophical formula stipulates that linguistic accounts must be built on empirical causal relations and natural law."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-2",
      "id": "fn1-2"
    }
  }, [_vm._v("2")])]), _vm._v(" This is all the more the case for a species whose environment is “biorigged,” its nest-like homes and towns consisting of apparently living plantlike materials bearing no resemblance to the cultivated geometries of the human parts of the city. Little surprise, then, that humans and Ariekei cannot even breathe the same air.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Lacking all cultural artifice, Ariekei have no signifiers that allow them to use a word to describe an action or object in a nonliteral, nonaffirmative manner. They cannot, for example, express disappointment by declaring “I felt crushed.” Likewise, joy would not be articulated with phrases such as “I am flying high.” For this species, such statements are lies.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("At first this fidelity to truth in the form of affirmation is admirable, yet it is not absolute. Due to the extreme limitations of what can be expressed in this manner, the Ariekei eventually develop a mechanism to produce and use similes (saying that one thing is like another) for which the referent is a real and embodied event or action. The protagonist Avice is one of the similes. As a girl, she was given something unpleasant to eat; she ate it out of obedience, not choice, and suffered for this. Later, one of the Hosts said of her, “When we talk about talking . . . most of us are like the girl who ate what was given to her. But we might "), _c('i', [_vm._v("choose")]), _vm._v(" what we say with her.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-3",
      "id": "fn1-3"
    }
  }, [_vm._v("3")])]), _vm._v(" Referring to Avice’s act in this way, "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12",
      "title": "12"
    }
  }, [_vm._v("as a limitation, indicates that at least some Ariekei find even the similes too constraining, at best a kind of making do."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-4",
      "id": "fn1-4"
    }
  }, [_vm._v("4")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("The difficulty inherent in communicating with the Ariekei leads the human bureaucrats to breed a race of doubles, called Ambassadors, who can replicate the Ariekei process of speaking two words simultaneously. They originate as clones with massive amounts of empathy, approximating a unified mind, to produce “speech spoken by a thinker thinking thoughts.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-5",
      "id": "fn1-5"
    }
  }, [_vm._v("5")])]), _vm._v(" Things go badly when some Ariekei begin to learn to turn the similes into contradictions at the same time that Bremen, the ruling planet, sends a special pair of Ambassadors whose “language” not only intoxicates the Ariekei but induces addiction to the sound of their voices, even as they say nothing more important than pleasantries and polite conversation. The addicted Ariekei begin to demand this “god-drug” and become incapable of taking care of themselves, their young, and their city.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Out of the chaos emerge two fundamentalist revolts, one against addiction and one against “lying.” The revolts are led by other Ariekei along with certain humans who become leaders by advocating for the purity of truthful, affirmative propositions with evident external natural and empirical referents. The novel thus pits signifying against naturalistic affirmative truth telling and expression against the purity of reference in a political and religious context. For the addictive Ambassadors and the human bureaucrats who breed the double that administers the god-drug, language is pure artifice in the form of statements with signification but no empirically true affirmation or external reference. Their language, nothing more than a postmodern signifying chain pushed to its limits so as to mislead, is posited as a necessity in the political and cultural realm to the point of becoming addictive in its own context. Affirmative statements about events that have actually occurred remain largely outside the bureaucratic system of language. It becomes the task of nonbureaucratic humans to teach the Ariekei to signify using metaphors in order to release them from their addiction but also to make good on some conception of reference within Embassytown to keep it from being overrun by the powerful forces of Bremen.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("SIGNIFYING AND SIGNS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_para"
  }, [_vm._v("The case for chains of signifiers and the overdetermination of meaning is often thought to be one of the chief accomplishments of postmodern philosophy. British literary scholar Alan Kirby claims that a defining trait of postmodern philosophy is its concern with the elusiveness of meaning and knowledge."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-6",
      "id": "fn1-6"
    }
  }, [_vm._v("6")])]), _vm._v(" Postmodernism, he writes, treated contemporary culture as a spectacle before "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13",
      "title": "13"
    }
  }, [_vm._v("which individuals were powerless to act but nevertheless were able to problematize questions about the real. These observations align with those of the French postmodern theorist Jean-Francois Lyotard, who famously describes the postmodern condition as the debunking of grand philosophical, scientific, political, religious, and historical narratives. Nevertheless, while there are still university courses that teach the literature of this debunking—for example, “Postmodern Fictions”—they are rare.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Kirby comments that outside of academia, postmodernism is dead, dead and buried. He claims that celebrated authors like Nabokov, Gibson, and B. S. Johnson, along with philosophers such as Derrida, Foucault, and Baudrillard, are no longer relevant to a generation accustomed to interacting, inventing, or directing their texts and drinking in the illusion that they are somehow controlling or at least managing their place in quick bites of online and reality TV worlds, the more banal the better. Such so-called pseudomodernism is said to have reactivated the individual along with the once-abandoned grand narratives and have taken the place of postmodernism. Pseudomodernism, he argues, is greatly inferior, and instead of calling reality into question, it takes itself for the real even while engendering nothing but the desire to return to the infantile state of being consumed by one’s activities. This territorialization is problematic.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Perhaps the technological and social revolutions of the last ten or more years leave little doubt about the veracity of this claim, but if we have definitively left something called postmodernism behind, it seems we still do not know what it is and to what extent it may or may not have contributed to the current state of affairs. This is the complaint made as long ago as June 2011 by British ethologist and evolutionary biologist Richard Dawkins on his Richard Dawkins Foundation for Reason and Science website. Dawkins and others, like physicist Alan Sokal, are making claims about postmodernism strikingly similar to Kirby’s criticism of pseudomodernism. When Dawkins puts a question on his website asking what “critical theory” might be, the clearest answer he gets from any commenter is that critical theory includes structuralism, poststructuralism, and postmodernism and that it is the provenance of “a few scruffy radicals.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-7",
      "id": "fn1-7"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("The problem is that this is not a definition, much less an explanation. Dawkins is left like the poor Duck in "), _c('i', [_vm._v("Alice in Wonderland")]), _vm._v(", who just wants to know what "), _c('i', [_vm._v("it")]), _vm._v(" means when the Mouse, who is telling a dry tale, says, “Stigand, the patriotic archbishop of Canterbury, found it advisable.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-8",
      "id": "fn1-8"
    }
  }, [_vm._v("8")])]), _vm._v(" For the Duck, "), _c('i', [_vm._v("it")]), _vm._v(" refers to something specific, like a frog or a worm. Like the Duck, Dawkins offers up crisp definitions of the biological concepts "), _c('i', [_vm._v("Lamarckian")]), _vm._v(" and "), _c('i', [_vm._v("mutationism")]), _vm._v("—definitions that are clear and concise, as well as informative and, as far as possible, truth "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14",
      "title": "14"
    }
  }, [_vm._v("telling. Like the Ariekei language, these terms are supposed to refer to nature, to the world outside of language that is empirically verifiable in all its aspects. Given the impossibility of such clear and concise naturalistic definitions for postmodernism, Dawkins asks if it is possible that words like "), _c('i', [_vm._v("postmodern")]), _vm._v(" mean nothing at all.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Even Kirby, who defends postmodernism as ironic, knowing, and playful—part of a world where a multiplicity of ideologies, worldviews, and voices can be heard—provides more of a description than a definition or explanation. Nevertheless, this failure to fill the gap does not mean Dawkins is right. It may simply mean that when and where postmodernism and associated concepts have been defined, its defenders have not been able to understand it well enough to translate its canonical terms into informative definitions. Still, whether or not one is an advocate of postmodernism, it is philosophically, historically, and culturally important to have a clear definition and/or explanation. Of course, there is always the risk that the Dawkins of the world won’t find even the most accurate explanations reasonable or sensible, but certainly it is worth the effort of reaching across the wider and wider abyss to try.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Coming on the tail of the infamous Sokal hoax, where the physicist submitted a postmodern parody of science to a cultural studies journal that published it as authentic, criticisms like Dawkins’s, as well as the responses to them, convinced many readers that postmodernism is a nebulous mishmash of free associations from scruffy intellectuals, a swirl of metaphors verging on lies. However, the truly astounding fact about postmodernism is that, whatever it became in the hands of enthusiasts, it originated as more or less what many of its recent practitioners and critics say it is not—that is, it began as a formal system or series of formal systems."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-9",
      "id": "fn1-9"
    }
  }, [_vm._v("9")])]), _vm._v(" Formal systems are often not well known or understood outside mathematics and computer and natural science, but they are pervasive across social sciences and humanities and in cultures that, unlike the Ariekei, are not grounded in a pure naturalism. However, it is quite possible that the postmodern call for the undoing of master narratives may not have recognized the formal basis of its own call for the radicalization of theory. Let us then begin by clarifying the formal structures that give way to contemporary demands for nonnaturalistic and nonrepresentational modes of thought.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("SCIENCE IS INDEPENDENT OF BOTH THE HUMAN MIND AND BEING")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_para"
  }, [_vm._v("In "), _c('i', [_vm._v("Postmodern Philosophy and the Scientific Turn")]), _vm._v(", I use the phrase “the scientific turn” to characterize a philosophical paradigm widely utilized in twentieth- and "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15",
      "title": "15"
    }
  }, [_vm._v("twenty-first-century Continental philosophy but that, I argue, originated primarily in Analytic philosophy as a turn toward the language of logic and toward discrete and formal computation in the philosophy of language and philosophy of mind. I made the claim that a number of significant postmodern philosophers and theorists embraced this turn but referred to it as “the linguistic turn,” and I argued that the linguistic turn, like its correlate in Analytic philosophy, finds its theoretical roots in a methodology broadly construed as mathematical or logical formalism.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("The modern move toward formalist thinking began in the sixteenth century with the work of Francis Vieta (1540–1603), who introduced abstraction in the form of letters into algebra."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-10",
      "id": "fn1-10"
    }
  }, [_vm._v("10")])]), _vm._v(" It was embraced by Bernhard Bolzano (1741–1848), who argued that science is a demonstrative system—a demonstrated theory that dispenses with verification. In the twentieth century, the French philosopher of science Jean Cavaillès (1903–1944) argued similarly that science is independent of both the human mind and being-in-itself and becomes an “object "), _c('i', [_vm._v("sui generis")]), _vm._v(".”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-11",
      "id": "fn1-11"
    }
  }, [_vm._v("11")])]), _vm._v(" This is not trivial, for it indicates that science is not one object among others in a cultural milieu but that it is autonomous, capable of generating its own intelligible elements, and that different sciences are unified by their common inclusion in this one system, “a self-enclosed dynamism” without beginning or end; science is also outside of time, especially outside the “lived experience of a consciousness.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-12",
      "id": "fn1-12"
    }
  }, [_vm._v("12")])]), _vm._v(" Science is understood to be an unending and unstoppable conceptual becoming, independent of what the scientist herself understands. As Cavaillès states, for all the natural sciences, including the biological sciences, “growth occurs without external borrowing. . . . [thus] there is a break between "), _c('i', [_vm._v("sensation or right opinion")]), _vm._v(" and science.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-13",
      "id": "fn1-13"
    }
  }, [_vm._v("13")])]), _vm._v(" This is why the structure of science is and only can be demonstration defined as logic, “the internal rule which directs it posits each of its steps,” as well as its essential traits: unity, necessary indefinite progression, and closure upon itself."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-14",
      "id": "fn1-14"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("However, unlike the logical positivists, Cavaillès does not accept the idea that the theory of science is logic alone, for that position ends up abandoning even truth as correspondence and is left with coherence theory, which stipulates that so-called atomic statements or judgments of perception—the reported sensations of a particular observer at a specific moment in time, formerly said to be irrefutable and therefore foundational—are really only the result of syntactical commitments—that is, the arrangement of signs."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-15",
      "id": "fn1-15"
    }
  }, [_vm._v("15")])]), _vm._v(" As noted previously, this is how the corrupt human politicians on Ariekei speak to one another; they speak by arranging signs in relation to one another and evade even the slightest reference to the naturalistic external state of affairs. The general weakness with this approach is that syntactical formalization cannot "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16",
      "title": "16"
    }
  }, [_vm._v("complete itself by itself; it cannot help but refer to objects, so the system is not, in fact, self-enclosed."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-16",
      "id": "fn1-16"
    }
  }, [_vm._v("16")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("For philosophers like Cavaillès, the logic of a formal system requires an ontology to complete it; in addition to the formal system, it requires reference to an exteriority, to objects, and not just to other signs in the system."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-17",
      "id": "fn1-17"
    }
  }, [_vm._v("17")])]), _vm._v(" But for hardened formalists, “all external questions are ‘metaphysical’ and therefore nonsensical,” so the term "), _c('i', [_vm._v("external")]), _vm._v(" refers only to systems of signs or, at most, to marks on paper, foregoing the necessity that signs are not objects that imply a reference to an external actuality."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-18",
      "id": "fn1-18"
    }
  }, [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Although Cavaillès stood in opposition to logical positivism, he is thought to have been influenced by mathematician David Hilbert’s formalism."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-19",
      "id": "fn1-19"
    }
  }, [_vm._v("19")])]), _vm._v(" Both argue that the truth of mathematics is in the demonstration, in the method of mathematics, so that science cannot be the product of the intentions of scientists. It is, instead, science itself that demonstrates what is true or not, so “the credit should and does go to science itself.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-20",
      "id": "fn1-20"
    }
  }, [_vm._v("20")])]), _vm._v(" Thus, mathematical objects—such as “the square root of −1”—are merely the product of the mathematical system that produces them, and outside this formal-linguistic context, they are meaningless. The conclusion here is that until and unless such formulations become objects of study, they represent no idea."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-21",
      "id": "fn1-21"
    }
  }, [_vm._v("21")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("If mathematical language extends itself, introducing its own formal idealizations, then the universe of mathematical objects is always in the process of formation, a conceptual becoming that cannot be stopped and will always be beyond the reach of individuals."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-22",
      "id": "fn1-22"
    }
  }, [_vm._v("22")])]), _vm._v(" As the mathematician Vladimir Tasić points out, the same thing can be said about “truth,” especially the claim that “all truth changes all the time,” a statement that cannot itself be proven to be true since no formal language can formulate its own theory of truth, and even higher concepts of truth are needed to do this."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-23",
      "id": "fn1-23"
    }
  }, [_vm._v("23")])]), _vm._v(" The implication is that if mathematics is always and endlessly formulating its own object, mathematical truth cannot possibly be formulated by finite human understanding. Gödel’s incompleteness theorem expresses this by claiming that higher concepts will have to be continued into the transfinite as part of a conceptual continuum that never ends."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-24",
      "id": "fn1-24"
    }
  }, [_vm._v("24")])]), _vm._v(" And yet, even Gödel notes that such concepts are put to the test, judged in human practice, in the lifeworld—in the cultural, social, and intellectual milieu.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Cavaillès’s chosen task seems to have been to reconcile formal logic with worldly applications—in a sense, to bring the Ariekei together with the human politicians: “Through the detour of abstract axiomatics, the formalist elevates himself to the general theory of formal systems and succeeds in constituting systems in which the structure has completely eliminated the content.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-25",
      "id": "fn1-25"
    }
  }, [_vm._v("25")])]), _vm._v(" "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_17",
      "title": "17"
    }
  }, [_vm._v("For this reason Cavaillès rejected at least some aspects of Edmund Husserl’s account of the relation between mathematics and the physical world, which, for Cavaillès, remained too much embedded in such a logical empiricism. He states that, essentially, if it is the case that “physical theory is simply an empty mathematical form applied to the invariant intuitive contents of the lifeworld,” mathematics does not truly augment our knowledge of the lifeworld but merely idealizes our power to predict."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-26",
      "id": "fn1-26"
    }
  }, [_vm._v("26")])]), _vm._v(" In other words, this is the old problem of the Kantian schematism, which is supposed to bring together an empirical intuition and a radically heterogeneous concept.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("After Cavaillès’s death at the hands of the Nazis, Georges Canguilhem wrote a book on the work and life of Cavaillès, and in 1948, Canguilhem became the director of the Institut d’histoire des sciences at the Sorbonne. Canguilhem also served from 1964 to 1968 as the president of the Jury d’Agrégation in philosophy, which provided him with institutional influence over the teaching of philosophy and helped consolidate the future influence of students."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-27",
      "id": "fn1-27"
    }
  }, [_vm._v("27")])]), _vm._v(" Among these students were Gilles Deleuze, Michel Foucault, Louis Althusser, and Jacques Derrida. With this in mind, in subsequent chapters we will look more closely at ideas Cavaillès grappled with that seem to have made their way into the philosophy of Gilles Deleuze.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("POSTMODERN PHILOSOPHY, DELEUZE, BERGSON, AND MERLEAU-PONTY")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_para"
  }, [_vm._v("As stated previously, for philosophers like Cavaillès, the logic of a formal system requires an ontology to complete it. This means there must be reference to exteriority—to objects and not only to other signs in the system. Although Gottlob Frege may have judged this as missing the point of a purely logical language, the task has been taken up by competing factions of philosophers, at one point characterized by Gilles Deleuze as either materialists or idealists. Materialism, often referred to as physicalism, is the doctrine that everything that exists is physical. Idealism clearly assumes the contrary position: that all that is real is either the content of one’s mind or at least its effect. Currently, throughout philosophy, it appears the materialists are in ascendance over the idealists.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("In "), _c('i', [_vm._v("Cinema 1: The Movement-Image")]), _vm._v(", Deleuze addresses the materialist and idealist positions by citing what he calls a “crisis of psychology,” which arose at a point in time when he believes it became impossible for philosophers to continue to place “images in consciousness and movements in space.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-28",
      "id": "fn1-28"
    }
  }, [_vm._v("28")])]), _vm._v(" Deleuze notes that this juxtaposition of qualitative images and quantitative spaces was "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_18",
      "title": "18"
    }
  }, [_vm._v("brought into question by both Henri Bergson and Maurice Merleau-Ponty. For Bergson, the matter was couched in the language of temporal duration and extensive spatiality. For Merleau-Ponty, what was at stake was a matter of the split between empiricism and what he refers to as intellectualism. It has been pointed out that this choice of terms is unfortunate as it does not accurately reflect the operative language of contemporary discussions, which tend to refer to either empiricist sense-data theories or neurophysiological physicalism."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-29",
      "id": "fn1-29"
    }
  }, [_vm._v("29")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Lawrence Hass argues convincingly that “intellectualists (such as Kant) and empiricists alike have held essentially the same theory, that is, Descartes’ theory.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-30",
      "id": "fn1-30"
    }
  }, [_vm._v("30")])]), _vm._v(" This is the theory that material objects cause sensations in the mind or brain, which then represents these sensations as objects. Hass adds that in contemporary philosophy, this view is present wherever a philosopher provides a list of sensory "), _c('i', [_vm._v("qualities")]), _vm._v(" such as “cold, hot, white, sour, hard, bitter, red.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-31",
      "id": "fn1-31"
    }
  }, [_vm._v("31")])]), _vm._v(" He contrasts this with what he argues is Merleau-Ponty’s view, which is that any so-called sensible is a matter of perceptual complexity in a larger field."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-32",
      "id": "fn1-32"
    }
  }, [_vm._v("32")])]), _vm._v(" Nevertheless, Deleuze utilizes the Bergsonian and Merleau-Pontyean language of materialism versus idealism or intellectualism to refer to the idea of a consciousness constituted out of pure material movements as opposed to a universe constituted from pure images in consciousness."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-33",
      "id": "fn1-33"
    }
  }, [_vm._v("33")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("In this context, Deleuze refers first to Bergson and Husserl, as each sought to overcome this opposition rooted in mind-body dualism. Deleuze’s own overcoming of the opposition of materialism and intellectualism led him to a concept he attributes to cinema: the "), _c('i', [_vm._v("movement-image")]), _vm._v(". Deleuze recognizes Bergson’s objection to cinema as an “ambiguous ally” in overcoming dualism. However, utilizing the concept of the movement-image, Deleuze offers a reading of Bergson that resituates Bergson’s philosophy in proximity to his own on this matter. He then turns abruptly from Husserl to Merleau-Ponty, who, he states, attempts “only incidentally a confrontation between cinema and phenomenology.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-34",
      "id": "fn1-34"
    }
  }, [_vm._v("34")])]), _vm._v(" Although framed in the context of Deleuze’s account of cinema’s movement-image, these comments are important with respect to the question of Deleuze’s relationship to both Bergson and Merleau-Ponty.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Undoubtedly each of the three is engaged in the undoing of dualism—understood as the relation between thought and movement—by slightly different means but each in accordance with the problematics set out at the beginning of this chapter, that is, providing an explanation of the relation between empiricist and formalist approaches to reality. If the structures of logic—its true assertions and formalist propositions—define or determine the real, does such a reconciliation arise only in relation to a theory of empiricist sense-data? Moreover, can either of these approaches be reconciled with movement and "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_19",
      "title": "19"
    }
  }, [_vm._v("change? Or, like the Ariekei, will we have to recognize as lies any statement or construct that arises on the basis of movement and change and so allows for statements that may not be able to be expressed as true assertions?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("For Bergson, this understanding does not start from logical constructs but from the image of one’s own body, which arises as one image among many in the material world. An image is neither representation nor thing—perhaps we may refer to it as an affect or a sensibility, not yet a perception. An image arises in relation to the afferent nerves transmitting disturbances to nerve centers and efferent nerves transmitting from the nerve centers to the body’s periphery and setting it in motion, thereby changing surrounding images."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-35",
      "id": "fn1-35"
    }
  }, [_vm._v("35")])]), _vm._v(" The body is able to be distinguished from all the other images insofar as it is the center of action in relation to all the other images. Additionally, it is distinguishable as a zone of affective life that does not automatically or mechanically respond to the material forces of the universe that affect it."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-36",
      "id": "fn1-36"
    }
  }, [_vm._v("36")])]), _vm._v(" Thus, for Bergson, the body image is a center of action or nonaction, an open zone of indetermination from which there is the option of acting back into the world or not acting at all. As such, it is not a mathematical point."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-37",
      "id": "fn1-37"
    }
  }, [_vm._v("37")])]), _vm._v(" Deleuze’s take on Bergson’s situating of the body as the central image is that “you may say that my body is matter or that it is an image.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-38",
      "id": "fn1-38"
    }
  }, [_vm._v("38")])]), _vm._v(" This is to say, as well, that the body or matter and what he will refer to as the movement-image are identical. This is an approach that will take us from here all the way to the final chapter of this book.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Deleuze recognizes that what he calls Bergson’s first thesis on movement is the idea that space (as conceived by mathematics) is infinitely divisible and therefore homogeneous but movement is indivisible and heterogeneous and so cannot be reconstituted out of either positions in space or instants in time."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-39",
      "id": "fn1-39"
    }
  }, [_vm._v("39")])]), _vm._v(" From this it follows, for Bergson, that because cinema is constituted of immobile sections (shots called any-instant-whatevers) to which movement is added, it does not meet his understanding of movement. Deleuze objects that each section is in fact mobile so that movement is not added to immobile sections because, even though every shot is fixed, spatial, and immobile, the means by which the shot becomes cinema, namely the projector, constitutes a movement-image."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-40",
      "id": "fn1-40"
    }
  }, [_vm._v("40")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("He correlates this with what he calls Bergson’s third thesis regarding duration: “Not only is the instant an immobile section of movement, but movement is a mobile section of duration, that is, of the Whole.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-41",
      "id": "fn1-41"
    }
  }, [_vm._v("41")])]), _vm._v(" Movement is therefore a change in quality. Deleuze does not name the qualities—hot, cold, red, white—but, like sense-data theorists, he refers to changes of quality. Additionally, he says that movement—such as pouring sugar into a glass—expresses a change in the "), _c('i', [_vm._v("whole")]), _vm._v(", a qualitative transition. For his part, Bergson did not affirm that "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_20",
      "title": "20"
    }
  }, [_vm._v("an instant of time is an immobile section of movement and that movement is a mobile section of duration, for this would imply that an instant, an immobile section, is part of duration or is duration.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Bergson is clear that duration cannot be reconstituted out of a series of immobile sections. The universe endures, it elaborates the absolutely new, but it is not the whole. What endures is the world, and the world, according to Bergson, is Open; it is not the given or givable, and so it is not the whole. The duration of sugar dissolving in a glass of water coincides with the duration of the one who watches and waits for it to dissolve; thus, duration is immanent to the open universe, which includes the observer."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-42",
      "id": "fn1-42"
    }
  }, [_vm._v("42")])]), _vm._v(" Deleuze wrangles with Bergson’s concepts in a manner that must be addressed, and later chapters of this book will take up the distinctions set out here in order to clarify the reasons for Deleuze’s reading of Bergson and to distinguish it from Bergson’s own conceptualizations.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("With respect to Merleau-Ponty, Deleuze argues that phenomenology establishes “‘natural perception’ and its conditions” as its norm."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-43",
      "id": "fn1-43"
    }
  }, [_vm._v("43")])]), _vm._v(" He states that “hence movement, perceived or made, must be understood not of course in the sense of an intelligible form (Idea) which would be "), _c('i', [_vm._v("actualized")]), _vm._v(" in a content, but as a sensible form (Gestalt), which organizes the perceptive field as a function of a situated intentional consciousness.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-44",
      "id": "fn1-44"
    }
  }, [_vm._v("44")])]), _vm._v(" First, we might want to pay attention to the distinction—if there is one—between actualizing an Idea and the formalist process of projecting or applying a formal structure onto an empirical world. Second, this raises the question of what is meant by natural perception. Merleau-Ponty calls it the undoing of classical psychology and physiology, which is to say the overthrow of sense-data theory, the idea of perception as a “mosaic of sensations” apprehended, as Descartes argued, by an inspection of the mind or held together by judgment that keeps all the separate data together."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-45",
      "id": "fn1-45"
    }
  }, [_vm._v("45")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Thus, natural perception, according to Merleau-Ponty, is perception of a "), _c('i', [_vm._v("whole")]), _vm._v("—“the interrelationships and structure of a whole”—which is a “spontaneous” way of seeing as opposed to an “analytical structure”—that is, the perception of isolated elements."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-46",
      "id": "fn1-46"
    }
  }, [_vm._v("46")])]), _vm._v(" This is the case for sound as much as for sight since a melody is not a sum of sounds but a perceived whole that can survive even being transposed from one key to another. Often sound or even touch melds with vision so we may perceive a “wooly blue” rug or, as the artist Paul Cézanne claimed, find color in shapes."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-47",
      "id": "fn1-47"
    }
  }, [_vm._v("47")])]), _vm._v(" In each case, it is the whole that creates a certain amount of constancy even amid changes in lighting that alter the color of objects, motion (such as when sitting on an unmoving train next to one that starts to move so it is unclear which is moving and which is still), or the shifting figure-ground of an optical illusion. Merleau-Ponty’s point is that "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_21",
      "title": "21"
    }
  }, [_vm._v("we anchor ourselves in objects in the world even if they are unstable and not the other way around because our perceptions are not fragmented sense-data that the mind orders."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-48",
      "id": "fn1-48"
    }
  }, [_vm._v("48")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("This is not exactly what Deleuze seems to say when he insists that for phenomenology, anchoring in the world is not the effect of "), _c('i', [_vm._v("objects")]), _vm._v(" asserting themselves but of a perceiving subject that is strictly a consciousness of the world and so organizes that world as the function of its situated intentional consciousness. Deleuze’s own view emerges here when his criticism extends to the idea that for phenomenology, the sensible form, the Gestalt, organizes the perceptual field for the situated intentional consciousness. This is apparently in place of his own preference, which is that of an intelligible form (Idea) “"), _c('i', [_vm._v("actualized in a content")]), _vm._v(".”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-49",
      "id": "fn1-49"
    }
  }, [_vm._v("49")])]), _vm._v(" What is key here is the concept of actualization. This is not the usual formalist account of the relation between concepts and the world but can be seen as a reformulation of formalism in Deleuzian terms, namely the "), _c('i', [_vm._v("actualization")]), _vm._v(" of an Idea in a content rather than the projection of a formal equation onto a material or empirical reality. Content may or may not be material or empirical but may be any type of sign, a broad concept whose implications we will examine in later chapters. For Merleau-Ponty, “objects and lighting form a system which tends toward a certain constancy and a certain level of stability,” but this does not occur through “the operation of the intelligence but through the very configuration of the field.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-50",
      "id": "fn1-50"
    }
  }, [_vm._v("50")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("It is for the same reasons, Merleau-Ponty continues, that the self-evidence of introspection has been thrown into doubt. Introspection—the interior examination of our own emotions in order to understand those of others—gives us almost nothing because anger, shame, love, and hate are not inner realities or hidden psychic facts. They are types of behavior and styles of conduct visible and felt from the "), _c('i', [_vm._v("outside")]), _vm._v(", just as emotions are "), _c('i', [_vm._v("disorganizing")]), _vm._v(" reactions, variations on our relations with others."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-51",
      "id": "fn1-51"
    }
  }, [_vm._v("51")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("When Merleau-Ponty applies these phenomenological concepts to film, he addresses it as a perceptual object that is, as Deleuze concurs, a temporal Gestalt, a whole."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-52",
      "id": "fn1-52"
    }
  }, [_vm._v("52")])]), _vm._v(" He argues that the viewer’s understanding of any single scene depends on what precedes it so that the same image can be read in a variety of ways. This “rhythm” exists as much for the sound in film as for the visuals as both require an internal organization invented by the film’s “creator,” especially as sound, including music, transforms the whole."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-53",
      "id": "fn1-53"
    }
  }, [_vm._v("53")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("It appears that Merleau-Ponty’s and Deleuze’s ideas may resonate with one another, so why does Deleuze object so strenuously to Merleau-Ponty’s phenomenology? One area in which Merleau-Ponty and Deleuze evidently differ is with respect to the question of meaning. Merleau-Ponty asks what a film "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_22",
      "title": "22"
    }
  }, [_vm._v("signifies, what it means, and Deleuze, as will be evident in "), _c('span', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 5")]), _vm._v(", most pointedly does not. Nevertheless, when Merleau-Ponty notes that films have stories and ideas, he cautions that the joy of art does not lie in representing because “the film does not mean anything but itself.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-54",
      "id": "fn1-54"
    }
  }, [_vm._v("54")])]), _vm._v(" There is no external referent for the film. Its meaning appears to be immanent to the film itself. With respect to our perception of films, Merleau-Ponty states that we see film images from the outside as behaviors, not as thoughts.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Clearly, for Deleuze, film images should not be translated into behaviors. They are images and signs. Films consist of movement-images, time-images, affection-images, and a range of different signs—opsigns, sonsigns, chronosigns, lectosigns, and noosigns, all of which make possible a semiology of the cinema."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-55",
      "id": "fn1-55"
    }
  }, [_vm._v("55")])]), _vm._v(" Of course, we must also ask what Merleau-Ponty means by behavior ("), _c('i', [_vm._v("comportment")]), _vm._v(") since, for him, it is clear that symbolic and mental activities count as “forms of behavior” in which signs are related to other signs and not merely to objects."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-56",
      "id": "fn1-56"
    }
  }, [_vm._v("56")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("These differences appear to be amplified by Merleau-Ponty’s claim that art and philosophy differ because “art is not meant to be a showcase for ideas and . . . contemporary philosophy consists not in stringing concepts together but in describing the mingling of consciousness with the world, its involvement with a body, and its coexistence with others.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-57",
      "id": "fn1-57"
    }
  }, [_vm._v("57")])]), _vm._v(" This statement gives us the opportunity to ask to what extent Deleuze is really at odds with the idea that consciousness is “thrown into the world, subject to the gaze of others.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-58",
      "id": "fn1-58"
    }
  }, [_vm._v("58")])]), _vm._v(" It is possible that Deleuze might agree with Merleau-Ponty’s claim that philosophers and filmmakers share the view of the world that the inside is also outside, but the manner in which this outside and inside are identified may be a crucial point of distinction between these two philosophers."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#rfn1-59",
      "id": "fn1-59"
    }
  }, [_vm._v("59")])]), _vm._v(" We will take these questions up in the chapters that follow; these questions will repeatedly return us to the matter of the relation between thought and world, matter and mind or memory, and what is at stake in this for Deleuze, Bergson, and Merleau-Ponty.")]), _vm._v(" "), _c('p', {
    staticClass: "notes_head"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NOTES")])]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-1",
      "id": "rfn1-1"
    }
  }, [_vm._v("1.")]), _vm._v(" China Miéville, "), _c('i', [_vm._v("Embassytown")]), _vm._v(" (London: Del Rey, 2012).")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-2",
      "id": "rfn1-2"
    }
  }, [_vm._v("2.")]), _vm._v(" Joseph Rouse, “Naturalism and Scientific Practices: A Concluding Scientific Postscript,” in "), _c('i', [_vm._v("Naturalized Epistemology and Philosophy of Science")]), _vm._v(", ed. Chienkuo Michael Mi and Ruey-lin Chen (Amsterdam: Rodopi, 2007), 61–86, 64.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-3",
      "id": "rfn1-3"
    }
  }, [_vm._v("3.")]), _vm._v(" Miéville, "), _c('i', [_vm._v("Embassytown")]), _vm._v(", 211.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-4",
      "id": "rfn1-4"
    }
  }, [_vm._v("4.")]), _vm._v(" Miéville, "), _c('i', [_vm._v("Embassytown")]), _vm._v(", 211.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_23",
      "title": "23"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-5",
      "id": "rfn1-5"
    }
  }, [_vm._v("5")]), _vm._v(". Miéville, "), _c('i', [_vm._v("Embassytown")]), _vm._v(", 107.")])]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-6",
      "id": "rfn1-6"
    }
  }, [_vm._v("6.")]), _vm._v(" Alan Kirby, “The Death of Postmodernism and Beyond,” "), _c('i', [_vm._v("Philosophy Now")]), _vm._v(", no. 58 (November/December 2006), "), _c('a', {
    attrs: {
      "href": "https://philosophynow.org/issues/58",
      "target": "_blank"
    }
  }, [_vm._v("https://philosophynow.org/issues/58")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-7",
      "id": "rfn1-7"
    }
  }, [_vm._v("7.")]), _vm._v(" See “The Richard Dawkins Foundation,” "), _c('a', {
    attrs: {
      "href": "https://www.richarddawkins.net",
      "target": "_blank"
    }
  }, [_vm._v("https://www.richarddawkins.net")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-8",
      "id": "rfn1-8"
    }
  }, [_vm._v("8.")]), _vm._v(" Lewis Carroll, "), _c('i', [_vm._v("The Philosopher’s Alice in Wonderland and Through the Looking-Glass")]), _vm._v(", introduction and notes by Peter Heath (New York: St. Martin’s Press, 1974), 30.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-9",
      "id": "rfn1-9"
    }
  }, [_vm._v("9.")]), _vm._v(" See Dorothea Olkowski, "), _c('i', [_vm._v("Postmodern Philosophy and the Scientific Turn")]), _vm._v(" (Bloomington: Indiana University Press, 2011), chap. 1, for an analysis of the Sokal hoax.")]), _vm._v(" "), _c('p', {
    staticClass: "notes0"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-10",
      "id": "rfn1-10"
    }
  }, [_vm._v("10.")]), _vm._v(" Florian Cajori, “A History of the Arithmetical Methods of Approximation to the Roots of Numerical Equations of One Unknown Quantity,” in Colorado College Publication, General Series no. 51, Science Series vol. 12 (November 1910): 182.")]), _vm._v(" "), _c('p', {
    staticClass: "notes0"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-11",
      "id": "rfn1-11"
    }
  }, [_vm._v("11.")]), _vm._v(" Jean Cavaillès, "), _c('i', [_vm._v("On Logic and the Theory of Science")]), _vm._v(", 2nd ed. (Paris: Presses Universitaires de France, 1960), in "), _c('i', [_vm._v("Phenomenology and the Natural Sciences: Essays and Translations")]), _vm._v(", ed. Theodore J. Kisiel and Joseph J. Kockelmans (Evanston, IL: Northwestern University Press, 1970), 370, 371.")]), _vm._v(" "), _c('p', {
    staticClass: "notes0"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-12",
      "id": "rfn1-12"
    }
  }, [_vm._v("12.")]), _vm._v(" Cavaillès, "), _c('i', [_vm._v("On Logic")]), _vm._v(", 371–372; Joseph Rouse, “Naturalism and Scientific Practices: A Concluding Scientific Postscript,” Division I Faculty Publications, Paper 20 (2007), 60–86, 64, accessed January 2018, "), _c('a', {
    attrs: {
      "href": "http://wesscholar.wesleyan.edu/div1facpubs/20",
      "target": "_blank"
    }
  }, [_vm._v("http://wesscholar.wesleyan.edu/div1facpubs/20")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "notes0"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-13",
      "id": "rfn1-13"
    }
  }, [_vm._v("13.")]), _vm._v(" Cavaillès, "), _c('i', [_vm._v("On Logic")]), _vm._v(", 372. Emphasis added.")]), _vm._v(" "), _c('p', {
    staticClass: "notes0"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-14",
      "id": "rfn1-14"
    }
  }, [_vm._v("14.")]), _vm._v(" Cavaillès, "), _c('i', [_vm._v("On Logic")]), _vm._v(", 373.")]), _vm._v(" "), _c('p', {
    staticClass: "notes0"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-15",
      "id": "rfn1-15"
    }
  }, [_vm._v("15.")]), _vm._v(" Cavaillès, "), _c('i', [_vm._v("On Logic")]), _vm._v(", 350. This type of sentence is called a protocol sentence.")]), _vm._v(" "), _c('p', {
    staticClass: "notes-in"
  }, [_vm._v("If we want to know whether a given sentence is meaningful or not, we must decide whether or not we associate with it a method of verification, for the meaning of a sentence lies in the method that we would employ to verify or falsify it. This means that we must specify the conditions under which it would be possible to verify the sentence. In stating what those conditions are, of course, we must use sentences. Unless we want to be involved in an infinite regress (or a circle), there must be some sentences that we can verify directly, which will then form the foundation for verifying other sentences. Those sentences are the protocol sentences. Protocol sentences were taken (initially at least) to express conditions whose obtaining or not is directly verifiable.")]), _vm._v(" "), _c('p', {
    staticClass: "notes-ni"
  }, [_vm._v("K. Ludwig, “Carnap, Neurath, and Schlick on Protocol Sentences,” "), _c('i', [_vm._v("Noûs")]), _vm._v(" 21, no. 4 (1987): 457–470, "), _c('a', {
    attrs: {
      "href": "http://www.jstor.org/stable/2215667",
      "target": "_blank"
    }
  }, [_vm._v("http://www.jstor.org/stable/2215667")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "notes0"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-16",
      "id": "rfn1-16"
    }
  }, [_vm._v("16.")]), _vm._v(" Cavaillès, "), _c('i', [_vm._v("On Logic")]), _vm._v(", 350.")]), _vm._v(" "), _c('p', {
    staticClass: "notes0"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_24",
      "title": "24"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-17",
      "id": "rfn1-17"
    }
  }, [_vm._v("17")]), _vm._v(". Cavaillès, "), _c('i', [_vm._v("On Logic")]), _vm._v(", 350.")])]), _vm._v(" "), _c('p', {
    staticClass: "notes0"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-18",
      "id": "rfn1-18"
    }
  }, [_vm._v("18.")]), _vm._v(" Cavaillès, "), _c('i', [_vm._v("On Logic")]), _vm._v(", 350.")]), _vm._v(" "), _c('p', {
    staticClass: "notes0"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-19",
      "id": "rfn1-19"
    }
  }, [_vm._v("19.")]), _vm._v(" Vladimir Tasić, "), _c('i', [_vm._v("Mathematics and the Roots of Postmodern Thought")]), _vm._v(" (Oxford: Oxford University Press, 2001), 85.")]), _vm._v(" "), _c('p', {
    staticClass: "notes0"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-20",
      "id": "rfn1-20"
    }
  }, [_vm._v("20.")]), _vm._v(" Tasić, "), _c('i', [_vm._v("Mathematics and the Roots")]), _vm._v(", 87, 88. Emphasis added.")]), _vm._v(" "), _c('p', {
    staticClass: "notes0"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-21",
      "id": "rfn1-21"
    }
  }, [_vm._v("21.")]), _vm._v(" Tasić, "), _c('i', [_vm._v("Mathematics and the Roots")]), _vm._v(", 86, 87.")]), _vm._v(" "), _c('p', {
    staticClass: "notes0"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-22",
      "id": "rfn1-22"
    }
  }, [_vm._v("22.")]), _vm._v(" Tasić, "), _c('i', [_vm._v("Mathematics and the Roots")]), _vm._v(", 88, 89.")]), _vm._v(" "), _c('p', {
    staticClass: "notes0"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-23",
      "id": "rfn1-23"
    }
  }, [_vm._v("23.")]), _vm._v(" Tasić, "), _c('i', [_vm._v("Mathematics and the Roots")]), _vm._v(", 88.")]), _vm._v(" "), _c('p', {
    staticClass: "notes0"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-24",
      "id": "rfn1-24"
    }
  }, [_vm._v("24.")]), _vm._v(" Tasić, "), _c('i', [_vm._v("Mathematics and the Roots")]), _vm._v(", 88.")]), _vm._v(" "), _c('p', {
    staticClass: "notes0"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-25",
      "id": "rfn1-25"
    }
  }, [_vm._v("25.")]), _vm._v(" Jean Ladrière, “Mathematics in a Philosophy of the Sciences,” trans. Theodore J. Kisiel, in "), _c('i', [_vm._v("Phenomenology and the Natural Sciences: Essays and Translations")]), _vm._v(", ed. Theodore J. Kisiel and Joseph J. Kockelmans (Evanston, IL: Northwestern University Press, 1970), 472.")]), _vm._v(" "), _c('p', {
    staticClass: "notes0"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-26",
      "id": "rfn1-26"
    }
  }, [_vm._v("26.")]), _vm._v(" Cavaillès, "), _c('i', [_vm._v("On Logic")]), _vm._v(", 351.")]), _vm._v(" "), _c('p', {
    staticClass: "notes0"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-27",
      "id": "rfn1-27"
    }
  }, [_vm._v("27.")]), _vm._v(" Peter Halliward, "), _c('i', [_vm._v("Concept and Form")]), _vm._v(": "), _c('i', [_vm._v("The “Cahiers pour l’Analyse” and Contemporary French Thought")]), _vm._v(", accessed January 2018, "), _c('a', {
    attrs: {
      "href": "http://cahiers.kingston.ac.uk/names/canguilhem.html",
      "target": "_blank"
    }
  }, [_vm._v("http://cahiers.kingston.ac.uk/names/canguilhem.html")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "notes0"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-28",
      "id": "rfn1-28"
    }
  }, [_vm._v("28.")]), _vm._v(" Gilles Deleuze, "), _c('i', [_vm._v("Cinema 1: The Movement-Image")]), _vm._v(", trans. Hugh Tomlinson and Barbara Habberjam (Minneapolis: University of Minnesota Press, 1986), 56. Originally published in French as "), _c('i', [_vm._v("Cinéma 1: L’Image-Movement")]), _vm._v(" (Paris: Les Éditions de Minuit, 1983).")]), _vm._v(" "), _c('p', {
    staticClass: "notes0"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-29",
      "id": "rfn1-29"
    }
  }, [_vm._v("29.")]), _vm._v(" See Lawrence Hass, "), _c('i', [_vm._v("Merleau-Ponty’s Philosophy")]), _vm._v(" (Bloomington: Indiana University Press, 2008), 27.")]), _vm._v(" "), _c('p', {
    staticClass: "notes0"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-30",
      "id": "rfn1-30"
    }
  }, [_vm._v("30.")]), _vm._v(" Hass, "), _c('i', [_vm._v("Merleau-Ponty’s Philosophy")]), _vm._v(", 28.")]), _vm._v(" "), _c('p', {
    staticClass: "notes0"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-31",
      "id": "rfn1-31"
    }
  }, [_vm._v("31.")]), _vm._v(" Hass, "), _c('i', [_vm._v("Merleau-Ponty’s Philosophy")]), _vm._v(", 29.")]), _vm._v(" "), _c('p', {
    staticClass: "notes0"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-32",
      "id": "rfn1-32"
    }
  }, [_vm._v("32.")]), _vm._v(" Hass, "), _c('i', [_vm._v("Merleau-Ponty’s Philosophy")]), _vm._v(", 31.")]), _vm._v(" "), _c('p', {
    staticClass: "notes0"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-33",
      "id": "rfn1-33"
    }
  }, [_vm._v("33.")]), _vm._v(" Deleuze, "), _c('i', [_vm._v("Cinema 1")]), _vm._v(", 56.")]), _vm._v(" "), _c('p', {
    staticClass: "notes0"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-34",
      "id": "rfn1-34"
    }
  }, [_vm._v("34.")]), _vm._v(" Deleuze, "), _c('i', [_vm._v("Cinema 1")]), _vm._v(", 57.")]), _vm._v(" "), _c('p', {
    staticClass: "notes0"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-35",
      "id": "rfn1-35"
    }
  }, [_vm._v("35.")]), _vm._v(" For my account of Bergson’s concept of the image, see Dorothea Olkowski, "), _c('i', [_vm._v("Gilles Deleuze and the Ruin of Representation")]), _vm._v(" (Berkeley: University of California Press, 1999), 95–97.")]), _vm._v(" "), _c('p', {
    staticClass: "notes0"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-36",
      "id": "rfn1-36"
    }
  }, [_vm._v("36.")]), _vm._v(" Henri Bergson, "), _c('i', [_vm._v("Matter and Memory")]), _vm._v(", trans. N. M. Paul and W. S. Palmer (New York: Zone Books, 1988), 168–169; Henri Bergson, "), _c('i', [_vm._v("Oeuvres")]), _vm._v(" (Paris: Presses Universitaires de France, 1963), 48–49, 53.")]), _vm._v(" "), _c('p', {
    staticClass: "notes0"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-37",
      "id": "rfn1-37"
    }
  }, [_vm._v("37.")]), _vm._v(" “The body image is exposed to the action of external causes that may threaten to disintegrate it. Some of these causes are reflected, producing perception, the measure of our possible action on things and their action on us. As such, perception expresses "), _c('i', [_vm._v("virtual action")]), _vm._v(", for there is always a distance between one body and another. When that distance decreases to zero, the body absorbs the action of external causes. This is affection, for it is then our own body that is sensed and the action upon ourselves is real action. The totality "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_25",
      "title": "25"
    }
  }, [_vm._v("of perceived images subsists even if our own body is no longer present but to annihilate the body is to destroy sensation which is simply a modification of the image called body.” See Dorothea Olkowski, “Bergson and Film,” in "), _c('i', [_vm._v("Film, Theory, and Philosophy: The Key Thinkers")]), _vm._v(", ed. Felicity Colman (Durham, NC: Acumen Press, 2009).")])]), _vm._v(" "), _c('p', {
    staticClass: "notes0"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-38",
      "id": "rfn1-38"
    }
  }, [_vm._v("38.")]), _vm._v(" Deleuze, "), _c('i', [_vm._v("Cinema 1")]), _vm._v(", 59.")]), _vm._v(" "), _c('p', {
    staticClass: "notes0"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-39",
      "id": "rfn1-39"
    }
  }, [_vm._v("39.")]), _vm._v(" Deleuze, "), _c('i', [_vm._v("Cinema 1")]), _vm._v(", 1.")]), _vm._v(" "), _c('p', {
    staticClass: "notes0"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-40",
      "id": "rfn1-40"
    }
  }, [_vm._v("40.")]), _vm._v(" Deleuze, "), _c('i', [_vm._v("Cinema 1")]), _vm._v(", 2–3.")]), _vm._v(" "), _c('p', {
    staticClass: "notes0"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-41",
      "id": "rfn1-41"
    }
  }, [_vm._v("41.")]), _vm._v(" Deleuze, "), _c('i', [_vm._v("Cinema 1")]), _vm._v(", 8.")]), _vm._v(" "), _c('p', {
    staticClass: "notes0"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-42",
      "id": "rfn1-42"
    }
  }, [_vm._v("42.")]), _vm._v(" Henri Bergson, "), _c('i', [_vm._v("Creative Evolution")]), _vm._v(", trans. Arthur Mitchell (Lanham, MD: University Press of America, 1983), 10–11. Published in French in Bergson, "), _c('i', [_vm._v("Oeuvres")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "notes0"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-43",
      "id": "rfn1-43"
    }
  }, [_vm._v("43.")]), _vm._v(" Deleuze, "), _c('i', [_vm._v("Cinema 1")]), _vm._v(", 57.")]), _vm._v(" "), _c('p', {
    staticClass: "notes0"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-44",
      "id": "rfn1-44"
    }
  }, [_vm._v("44.")]), _vm._v(" Deleuze, "), _c('i', [_vm._v("Cinema 1")]), _vm._v(", 57. Emphasis added.")]), _vm._v(" "), _c('p', {
    staticClass: "notes0"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-45",
      "id": "rfn1-45"
    }
  }, [_vm._v("45.")]), _vm._v(" Maurice Merleau-Ponty, "), _c('i', [_vm._v("Sense and Non-Sense")]), _vm._v(", trans. Patricia Allen Dreyfus (Evanston, IL: Northwestern University Press, 1992), 50.")]), _vm._v(" "), _c('p', {
    staticClass: "notes0"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-46",
      "id": "rfn1-46"
    }
  }, [_vm._v("46.")]), _vm._v(" Merleau-Ponty, "), _c('i', [_vm._v("Sense and Non-Sense")]), _vm._v(", 49.")]), _vm._v(" "), _c('p', {
    staticClass: "notes0"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-47",
      "id": "rfn1-47"
    }
  }, [_vm._v("47.")]), _vm._v(" Merleau-Ponty, "), _c('i', [_vm._v("Sense and Non-Sense")]), _vm._v(", 51.")]), _vm._v(" "), _c('p', {
    staticClass: "notes0"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-48",
      "id": "rfn1-48"
    }
  }, [_vm._v("48.")]), _vm._v(" Merleau-Ponty, "), _c('i', [_vm._v("Sense and Non-Sense")]), _vm._v(", 52.")]), _vm._v(" "), _c('p', {
    staticClass: "notes0"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-49",
      "id": "rfn1-49"
    }
  }, [_vm._v("49.")]), _vm._v(" Deleuze, "), _c('i', [_vm._v("Cinema 1")]), _vm._v(", 57.")]), _vm._v(" "), _c('p', {
    staticClass: "notes0"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-50",
      "id": "rfn1-50"
    }
  }, [_vm._v("50.")]), _vm._v(" Merleau-Ponty, "), _c('i', [_vm._v("Sense and Non-Sense")]), _vm._v(", 51.")]), _vm._v(" "), _c('p', {
    staticClass: "notes0"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-51",
      "id": "rfn1-51"
    }
  }, [_vm._v("51.")]), _vm._v(" Merleau-Ponty, "), _c('i', [_vm._v("Sense and Non-Sense")]), _vm._v(", 52–53.")]), _vm._v(" "), _c('p', {
    staticClass: "notes0"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-52",
      "id": "rfn1-52"
    }
  }, [_vm._v("52.")]), _vm._v(" Merleau-Ponty, "), _c('i', [_vm._v("Sense and Non-Sense")]), _vm._v(", 54.")]), _vm._v(" "), _c('p', {
    staticClass: "notes0"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-53",
      "id": "rfn1-53"
    }
  }, [_vm._v("53.")]), _vm._v(" Merleau-Ponty, "), _c('i', [_vm._v("Sense and Non-Sense")]), _vm._v(", 55, 56.")]), _vm._v(" "), _c('p', {
    staticClass: "notes0"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-54",
      "id": "rfn1-54"
    }
  }, [_vm._v("54.")]), _vm._v(" Merleau-Ponty, "), _c('i', [_vm._v("Sense and Non-Sense")]), _vm._v(", 57.")]), _vm._v(" "), _c('p', {
    staticClass: "notes0"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-55",
      "id": "rfn1-55"
    }
  }, [_vm._v("55.")]), _vm._v(" Gilles Deleuze, "), _c('i', [_vm._v("Cinema 2: The Time-Image")]), _vm._v(", trans. Hugh Tomlinson and Barbara Habberjam (Minneapolis: University of Minnesota Press, 1989), 25. Originally published in French as "), _c('i', [_vm._v("Cinéma II: l’Image-temps")]), _vm._v(" (Paris: Les Éditions de Minuit, 1985).")]), _vm._v(" "), _c('p', {
    staticClass: "notes0"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-56",
      "id": "rfn1-56"
    }
  }, [_vm._v("56.")]), _vm._v(" Maurice Merleau-Ponty, "), _c('i', [_vm._v("The Structure of Behavior")]), _vm._v(", trans. Alden L. Fisher (Boston: Beacon Press, 1963), 121. Deleuze takes his assessment of phenomenology and film not from Merleau-Ponty but from Albert Lattay’s "), _c('i', [_vm._v("Logique du cinema")]), _vm._v(", which, he states, is “phenomenologically inspired.” See Deleuze, "), _c('i', [_vm._v("Cinema 1")]), _vm._v(", 226n3.")]), _vm._v(" "), _c('p', {
    staticClass: "notes0"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-57",
      "id": "rfn1-57"
    }
  }, [_vm._v("57.")]), _vm._v(" Merleau-Ponty, "), _c('i', [_vm._v("Sense and Non-Sense")]), _vm._v(", 59.")]), _vm._v(" "), _c('p', {
    staticClass: "notes0"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-58",
      "id": "rfn1-58"
    }
  }, [_vm._v("58.")]), _vm._v(" Merleau-Ponty, "), _c('i', [_vm._v("Sense and Non-Sense")]), _vm._v(", 59.")]), _vm._v(" "), _c('p', {
    staticClass: "notes0"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253054708_Chapter_1#fn1-59",
      "id": "rfn1-59"
    }
  }, [_vm._v("59.")]), _vm._v(" Merleau-Ponty, "), _c('i', [_vm._v("Sense and Non-Sense")]), _vm._v(", 59.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8427742","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780253054708_Chapter_1.vue
// module id = 75
// module chunks = 0